import script from "./TabImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabImages.vue?vue&type=script&setup=true&lang=ts"

import "./TabImages.vue?vue&type=style&index=0&id=60511101&lang=scss&scoped=true"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60511101"]])

export default __exports__